/**
 * Unified tracking for GA4 + Meta Pixel.
 * Call these from any component to track conversion events.
 */

function gtag(...args) {
  if (window.gtag) window.gtag(...args);
}

function fbq(...args) {
  if (window.fbq) window.fbq(...args);
}

// Homepage CTA click
export function trackCTAClick(ctaName, destination) {
  gtag("event", "cta_click", { cta_name: ctaName, destination });
  fbq("trackCustom", "CTAClick", { cta_name: ctaName, destination });
}

// Sign up / registration
export function trackSignUp(method = "email") {
  gtag("event", "sign_up", { method });
  fbq("track", "CompleteRegistration", { content_name: method });
}

// Login
export function trackLogin() {
  gtag("event", "login", { method: "email" });
}

// Pricing page visit
export function trackPricingVisit() {
  gtag("event", "view_pricing", { page: "/pricing" });
  fbq("track", "ViewContent", { content_type: "pricing" });
}

// Property detail click (viewing a deal)
export function trackPropertyClick(propertyId, dealScore, price) {
  gtag("event", "view_item", {
    item_id: propertyId,
    deal_score: dealScore,
    value: price,
    currency: "USD",
  });
  fbq("track", "ViewContent", {
    content_type: "property",
    content_ids: [propertyId],
    value: price,
    currency: "USD",
  });
}

// Save / favorite a deal
export function trackSaveDeal(propertyId) {
  gtag("event", "add_to_wishlist", { item_id: propertyId });
  fbq("track", "AddToWishlist", { content_ids: [propertyId] });
}

// Email signup / lead capture
export function trackEmailSignup(market) {
  gtag("event", "generate_lead", { lead_source: "email_capture", market });
  fbq("track", "Lead", { content_name: "deal_alerts", market });
}

// Subscription checkout started
export function trackCheckoutStarted(plan, price) {
  gtag("event", "begin_checkout", { currency: "USD", value: price, items: [{ item_name: plan }] });
  fbq("track", "InitiateCheckout", { content_name: plan, value: price, currency: "USD" });
}

// Subscription completed
export function trackSubscriptionCompleted(plan, price) {
  gtag("event", "purchase", { currency: "USD", value: price, items: [{ item_name: plan }] });
  fbq("track", "Purchase", { content_name: plan, value: price, currency: "USD" });
}

// Search performed
export function trackSearch(query) {
  gtag("event", "search", { search_term: query });
  fbq("track", "Search", { search_string: query });
}
